import { createSelector } from '@reduxjs/toolkit';
export const widgetsReducerSelector = (state) => state.widgets;
export const dashboardWidgetsReducerSelector = (state) => state.dashboardWidgets;
export const widgetsSelector = createSelector(widgetsReducerSelector, (reducer) => reducer.data);
export const dashboardWidgetsSelector = createSelector(dashboardWidgetsReducerSelector, (reducer) => reducer.data);
export const widgetLoadingIdSelector = createSelector(widgetsReducerSelector, (reducer) => reducer.widgetLoadingId);
export const widgetsWithRelationsSelector = createSelector([widgetsSelector, dashboardWidgetsSelector], (widgets, dashboardWidgets) => {
    const data = widgets.map((widget) => {
        var _a;
        const rel_dashboardWidgetInst = (_a = dashboardWidgets.find((dw) => dw.widget === widget.id)) !== null && _a !== void 0 ? _a : widget;
        return Object.assign(Object.assign({}, widget), { rel_dashboardWidgetInst });
    });
    return data;
});
export const widgetsByDashboardSelector = (dashboardId) => createSelector(widgetsWithRelationsSelector, (widgets) => {
    return widgets.filter((widget) => widget.rel_dashboardWidgetInst.dashboard === dashboardId);
});
